/**
 * Whether a hex color (#RGB or #RRGGBB) is light enough that it needs a dark
 * background to stay visible (e.g. white-ish logo silhouettes on the editor's
 * light cards). Invalid input counts as dark.
 */
export function isLightHexColor(hex: string): boolean {
  const value = hex.replace('#', '');
  const full =
    value.length === 3
      ? value
          .split('')
          .map((c) => c + c)
          .join('')
      : value;
  if (!/^[0-9a-fA-F]{6}$/.test(full)) return false;

  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255 > 0.62;
}
